import { clearLocalStorage } from "./clearLocalStorage";

let interceptorInstalled = false;
let redirectStarted = false;

const prepareAuthenticatedRequest = (resource, options = {}) => {
  const requestHeaders =
    options.headers ||
    (typeof Request !== "undefined" && resource instanceof Request
      ? resource.headers
      : undefined);
  const headers = new Headers(requestHeaders || {});
  const hasBearerToken = /^Bearer\s+\S+/i.test(
    headers.get("Authorization") || ""
  );

  if (!hasBearerToken) {
    return { resource, options, hasBearerToken: false };
  }

  // Ensure Laravel returns a JSON 401 instead of redirecting API requests.
  headers.set("Accept", "application/json");

  return {
    resource,
    options: { ...options, headers },
    hasBearerToken: true,
  };
};

const getLogoutReason = async (response) => {
  if (response.status !== 401) return null;

  try {
    const data = await response.clone().json();
    if (data?.status === "force_logout" || data?.force_logout === true ||
        data?.code === "PASSWORD_RESET_REQUIRED") {
      return "password_reset_required";
    }
    return data?.message === "Unauthenticated." ? "unauthenticated" : null;
  } catch (error) {
    return null;
  }
};

export const installAuthFetchInterceptor = () => {
  if (
    interceptorInstalled ||
    typeof window === "undefined" ||
    typeof window.fetch !== "function"
  ) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (resource, options = {}) => {
    const preparedRequest = prepareAuthenticatedRequest(resource, options);
    const response = await originalFetch(
      preparedRequest.resource,
      preparedRequest.options
    );

    const logoutReason = preparedRequest.hasBearerToken
      ? await getLogoutReason(response) : null;
    if (logoutReason) {
      clearLocalStorage();

      if (!redirectStarted) {
        redirectStarted = true;
        window.location.replace(logoutReason === "password_reset_required"
          ? "/?password_reset_required=1" : "/");
      }
    }

    return response;
  };

  interceptorInstalled = true;
};
